import { DynamicStyleSheet } from '@pulsar/core';
import { Platform } from 'src/libs/platform';

export default DynamicStyleSheet.create(theme => ({
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    ...Platform.select({
      ios: {
        height: 52,
      },
      default: {
        height: 56,
      },
    }),
  },
  inner: {
    fontSize: theme.fontSizes[3],
    color: theme.colors.textDefault,
    fontWeight: '600',
    ...Platform.select({
      ios: {
        flexShrink: 1,
      },
      default: {
        flexGrow: 1,
      },
    }),
  },
  side: {
    flexDirection: 'row',
    flexGrow: 1,
    flexShrink: 0,
    color: theme.colors.headerControl,
    ...Platform.select({
      ios: {
        minWidth: '20%', // @todo fix flexBasis in native apps
        flexBasis: 0,
      },
      default: {
        flexGrow: 0,
      },
    }),
  },
  left: {
    justifyContent: 'flex-start',
    paddingLeft: theme.space[1],
    paddingRight: theme.space[2],
  },
  right: {
    justifyContent: 'flex-end',
    paddingRight: theme.space[1],
    paddingLeft: theme.space[2],
  },
}));
